<template>
    <v-container fluid class="superTable">
        <v-row no-gutters>
            <v-col sm="4">
                <v-text-field
                    v-model="search"
                    prepend-inner-icon="mdi-magnify"
                    :placeholder="$t('actions.search')"
                    outlined
                    clearable
                    @click:clear="clearAction"
                    @keyup.esc="clearAction"
                    @keyup.enter="searchAction"
                    class="superTable__search"
                ></v-text-field>
            </v-col>
            <v-col sm="4">
                <Button
                    class="ml-4"
                    @clicked="searchAction"
                    outlined
                    depressed
                    :text="$t('modules.preRegistration.table.search.buttonLabel')"
                ></Button>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col sm="12">
                <v-data-table
                    :headers="headers"
                    :items="data"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    hide-default-footer
                    item-key="id"
                    class="superTable__table"
                    style="table-layout: fixed"
                >

                    <template v-slot:[`item.name`]="{item}">
                        <div class="superTable__table__item__name">
                            {{ item.name }}
                        </div>
                    </template>


                    <template v-slot:[`item.status`]="{item}">
                        <v-icon size="12" :color="(item.status === 'Preinscripto') ? 'success' : 'grey lighten-2'">mdi-circle</v-icon>
                    </template>

                    <template v-slot:[`item.action`]="{item}">
                        <v-menu bottom left v-if="item.status === 'Preinscripto' && (permissions.read || permissions.update || permissions.delete)">
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" class="superTable__table__item__action">mdi-dots-vertical</v-icon>
                            </template>
                            <v-list class="pa-0">
                                <v-list-item v-if="permissions.read" @click="openDetails(item.id)">
                                    <v-list-item-title>
                                        <v-icon>mdi-eye</v-icon>
                                        {{ $t('modules.scholarships.table.search.details') }}
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="permissions.update" @click="editItem(item.id)">
                                    <v-list-item-title>
                                        <v-icon>mdi-pencil</v-icon> {{ $t('actions.edit') }}
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="permissions.delete" @click="deleteItem(item.id)">
                                    <v-list-item-title>
                                        <v-icon>mdi-delete</v-icon> {{ $t('modules.preRegistration.table.rowActions.unsubscribe') }}
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                </v-data-table>
                <v-divider class="mt-4 mb-8"></v-divider>
            </v-col>
        </v-row>
        <v-row no-gutters align="center">
            <v-col sm="3">
                <span class="caption d-inline-block">{{ `${itemsCount.startItem} - ${itemsCount.endItem} ${$t('modules.preRegistration.table.of')} ${totalItems}` }}</span>
                <v-select
                    :value="itemsPerPage"
                    :items="itemsPerPageAvailable"
                    :placeholder="itemsPerPage.toString()"
                    outlined
                    class="superTable__paginationSelect d-inline-block ml-4"
                    @change="$emit('itemsPerPageChange', $event)"
                ></v-select>
            </v-col>
            <v-col sm="6" class="text-center">
                <v-pagination @input="$emit('inputPagination', $event)" :value="page" :length="pageCount" class="superTable__pagination"></v-pagination>
            </v-col>
            <v-col sm="3" align="right">
                <v-text-field
                    :value="page"
                    max="pageCount"
                    outlined
                    class="superTable__paginationInput d-inline-block mr-4"
                ></v-text-field>
                <span class="caption d-inline-block">{{$t('modules.preRegistration.table.goToPage')}}</span>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import Button from '@/components/Button/Button';

    export default {
        name: 'SuperTable',
        components: { Button },
        props: {
            data: Array,
            headers: Array,
            pageCount: { type: Number, default: 1 },
            page: { type: Number, default: 0 },
            totalItems: { type: Number, default: 0 },
            itemsPerPage: { type: Number, default: 20 },
            permissions: {read: false, update: false, delete: false},
        },
        data() {
            return {
                search: null,
                itemsPerPageAvailable: [20, 50, 100, 200],
            }
        },
        methods:{
            clearAction() {
                this.search = null
                this.searchAction()
            },
            searchAction() {
                this.$emit('searchAction', this.search);
            },
            editItem(id) {
                this.$emit('update', id);
            },
            deleteItem(id) {
                this.$emit('delete', id);
            },
            openDetails(id) {
                if (this.permissions.read) this.$router.push(`preregistration/detail/${id}`);
            }
        },
        computed: {
            itemsCount () {
                const counter = {
                    // totalItems: this.users.length,
                    startItem: (( this.page * this.itemsPerPage ) - this.itemsPerPage ) + 1,
                    endItem: this.page * this.itemsPerPage
                };

                if ( counter.endItem > this.data.length ) {
                    counter.endItem = this.data.length
                }

                return counter
            }
        },
    };
</script>

